import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { CommonConfig } from "../../CommonConfig.js";
import SimpleBackdrop from "../../utils/general";
import api from "../../utils/api";
import cogoToast from "cogo-toast";
import APIConstant from "../../utils/constant";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Tooltip as MuiTooltip,
} from "@material-ui/core";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import Loader from "components/Shared/Loader/Loader";
import CustomInput from "components/CustomInput/CustomInput.js";
import { Tooltip } from "primereact/tooltip";
import { Autocomplete } from "@mui/material";
import { MultiSelect } from "primereact/multiselect";
class Item extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      ItemSearchListHSCode: [],
      ItemMasterID: "",
      loading: false,
      UserId: "",
      Token: "",
      GetItemMasterList: [],
      rowsPerPageOptions: CommonConfig.dataTableConfig.rowsPerPageOptions,
      rowsPerPage: CommonConfig.dataTableConfig.rowsPerPage,
      search: null,
      ItemMasterHsCode: "",
      ItemMasterHsCodeErr: false,
      ItemItemMasterHsCodeErrText: "",
      ItemMasterLabelName: "",
      ItemMasterLabelNameErr: false,
      ItemMasterLabelNameErrText: "",
      AddItemMasterModal: false,
      EditItemMasterTypeModal: false,
      DeleteItemMasterTypeModal: false,
      userPageAccess: [],
      searchDetails: {},
      unitList: [],
      subWarehouseList: [],
      subCategoryList: [],
      gstList: [],
    };
  }

  componentDidMount = async () => {
    let data = localStorage.getItem("Infodata");
    let Userrole = JSON.parse(localStorage.getItem("Userdata"));
    let token = localStorage.getItem("Token");
    let userPageAccess = localStorage.getItem("PageAccess");
    let lockstatus = localStorage.getItem("LockStatus");
    // if (lockstatus == 0) {
    if (token !== null) {
      this.setState({
        UserId: data,
        Token: token,
        userPageAccess: userPageAccess,
      });
      await this.GetItemMasterListByType(data);
      await this.getUnitList(data);
      await this.getSubWareHouseList(data);
      await this.getSubCategoryList(data);
      await this.getGSTList(data);
    } else {
      this.props.history.push("/login");
    }
    // } else {
    //   this.props.history.push("/auth/lockscreen");
    // }
  };

  getUnitList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetUnitMaster, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data;
          this.setState({
            unitList: filterArry,
          });
        }
      })
      .catch((err) => { });
  };

  getSubWareHouseList = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetSubWareHouseList, params)
      .then((response) => {
        if (response.Success === 1) {
          this.setState({
            subWarehouseList: response.Data.map((subWareHouse) => ({
              label: subWareHouse.Name,
              value: subWareHouse._id,
            })),
          });
        }
      })
      .catch((err) => { });
  };

  getSubCategoryList = async (UserId) => {
    let params = {
      ID: UserId,
    };
    api
      .post(APIConstant.path.GetSubCategoryMaster, params)
      .then(async (response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.map((data) => ({
            ...data,
            label: `${data.label}(${data.CategoryName})`,
          }));

          this.setState({ subCategoryList: filterArry });
        }
      })
      .catch((err) => { });
  };

  getGSTList = async (UserId) => {
    let params = {
      ID: UserId,
      Type: "GST",
    };
    api
      .post(APIConstant.path.GetMasterListByType, params)
      .then((response) => {
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin").map(
            (data) => ({
              label: data.name,
              value: data.value,
            })
          );

          this.setState({ gstList: filterArry });
        }
      })
      .catch((err) => { });
  };

  actionBodyTemplateSrNo = (data, props) => {
    return props.rowIndex + 1;
  };

  actionTemplate = (rowData, props) => {
    return (
      <div class="bill-action icon-only-btn" style={{ display: "flex" }}>
        {this.state.userPageAccess.includes("Edit Item/Goods") ? (
          <div onClick={(e) => this.handleOpenItem(rowData, "EditMasterType")}>
            {" "}
            <i class="icon-editImage"></i>{" "}
          </div>
        ) : null}
        {this.state.userPageAccess.includes("Delete Item/Goods") ? (
          <div
            onClick={(e) =>
              this.handleOpenItem(rowData, "DeleteItemMasterType")
            }
          >
            {" "}
            <i class="icon-delete"></i>{" "}
          </div>
        ) : null}
      </div>
    );
  };

  GetItemMasterListByType = async (UserId) => {
    let params = {
      UserId,
    };
    api
      .post(APIConstant.path.GetItemMasterList, params)
      .then(async (res) => {
        let response = await res;
        if (response.Success === 1) {
          let filterArry = response.Data.filter((x) => x.UserId != "Admin");

          this.setState({ GetItemMasterList: filterArry });
        }
      })
      .catch((err) => { });
  };

  handleOpenItem = (item, type) => {
    if (type === "AddItemMaster") {
      this.setState({ AddItemMasterModal: true });
    } else if (type === "EditMasterType") {
      this.setState({
        AddItemMasterModal: true,
        ItemMasterHsCode: item.product_hsn_code,
        ItemMasterID: item.ItemHSNCodeID,
      });
      this.SearchItemCodeList(item, "Edit");
    } else if (type === "DeleteItemMasterType") {
      this.setState({
        DeleteItemMasterTypeModal: true,
        ItemMasterID: item.ItemHSNCodeID,
      });
    }
  };

  handlehandleClose = (type) => {
    if (type === "AddItemMaster") {
      this.setState({
        AddItemMasterModal: false,
        ItemMasterHsCode: "",
        ItemMasterHsCodeErr: false,
        ItemItemMasterHsCodeErrText: "",
        ItemMasterID: "",
        ItemSearchListHSCode: [],
      });
    } else if (type === "EditMasterType") {
      this.setState({ EditItemMasterTypeModal: false });
    } else if (type === "DeleteItemMasterType") {
      this.setState({ DeleteItemMasterTypeModal: false, ItemMasterID: "" });
    }
  };

  handleChangeItem = (e, type) => {
    if (type === "ItemMasterLabelName") {
      if (CommonConfig.isEmpty(e.target.value)) {
        this.setState({
          ItemMasterLabelName: e.target.value,
          ItemMasterLabelNameErr: true,
          ItemMasterLabelNameErrText: `Please enter Type.`,
        });
      } else {
        this.setState({
          ItemMasterLabelName: e.target.value,
          ItemMasterLabelNameErr: false,
          ItemMasterLabelNameErrText: "",
        });
      }
    } else if (type === "ItemMasterHsCode") {
      if (CommonConfig.isEmpty(e.target.value)) {
        this.setState({
          ItemMasterHsCode: e.target.value,
          ItemMasterHsCodeErr: true,
          ItemItemMasterHsCodeErrText: `Please enter Item HsCode/ Product Name.`,
        });
      } else {
        this.setState({
          ItemMasterHsCode: e.target.value,
          ItemMasterHsCodeErr: false,
          ItemItemMasterHsCodeErrText: "",
        });
      }
    }
  };

  validationItem = () => {
    let formIsValid = true;
    let message = "";
    if (CommonConfig.isEmpty(this.state.ItemMasterHsCode)) {
      this.setState({
        ItemMasterHsCode: "",
        ItemMasterHsCodeErr: true,
        ItemItemMasterHsCodeErrText: "Item HsCode is required.",
      });
      formIsValid = false;
    } else {
      this.setState({
        ItemMasterHsCodeErr: false,
        ItemItemMasterHsCodeErrText: "",
      });
    }

    this.state.ItemSearchListHSCode.forEach((item) => {
      if (item.chapter_name) {
        if (!item.subWarehouse || item.subWarehouse?.length <= 0) {
          formIsValid = false;
          message = "Please select sub warehouse";
        } else if (CommonConfig.isEmpty(item.subCategory)) {
          formIsValid = false;
          message = "Please select sub category";
        } else if (CommonConfig.isEmpty(item.unit)) {
          formIsValid = false;
          message = "Please select unit";
        }
      }
    });
    return { formIsValid, message };
  };

  AddItemMaster = () => {
    if (this.validationItem().formIsValid) {
      try {
        this.setState({ loading: true });
        Loader.show();

        let Selected = this.state.ItemSearchListHSCode.filter(
          (x) => !!x.chapter_name
        ).length
          ? this.state.ItemSearchListHSCode.filter((x) => !!x.chapter_name)
          : [];

        if (Selected.length) {
          Selected = Selected.map((data) => {
            return {
              chapter_name: data.chapter_name,
              product_description: data.product_description,
              product_hsn_code: data.product_hsn_code,
              subCategoryId: data.subCategory,
              subCategory:
                this.state.subCategoryList.filter(
                  (category) => data.subCategory === category.value
                )?.[0]?.label || [],
              subWarehouse: data.subWarehouse.map((warehouse) => {
                return {
                  id: warehouse,
                  name:
                    this.state.subWarehouseList.filter(
                      (subwarehouse) => warehouse === subwarehouse.value
                    )?.[0]?.label || [],
                };
              }),
              unitId: data.unit,
              unit: this.state.unitList.filter(
                (item) => data.unit === item.value
              )?.[0]?.label,
              product_rate: data.product_rate,
              product_cess: CommonConfig.isEmpty(data.product_cess)
                ? 0
                : data.product_cess,
            };
          });
          let params = {
            List: Selected,
            UserID: this.state.UserId,
            ItemHSNCodeID: this.state.ItemMasterID,
          };
          api
            .post(APIConstant.path.AddUpdateMasterItem, params)
            .then((res) => {
              if (res.Success == 1) {
                this.setState({
                  AddItemMasterModal: false,
                  ItemMasterHsCode: "",
                  ItemMasterHsCodeErr: false,
                  ItemItemMasterHsCodeErrText: "",
                  ItemMasterID: "",
                  ItemSearchListHSCode: [],
                });
                this.GetItemMasterListByType(this.state.UserId);
                cogoToast.success(res.Message);
                Loader.hide();
              } else {
                this.setState({ loading: false });
                cogoToast.error(res.Message);
                Loader.hide();
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      } catch (e) {
        console.log(e);
      }
    } else {
      cogoToast.error(this.validationItem().message);
    }
  };

  SearchItemCodeList = async (ItemMasterHsCode, Type) => {
    if (!CommonConfig.isEmpty(ItemMasterHsCode)) {
      this.setState({ loading: true });
      Loader.show();

      let params = {
        ID:
          Type == "Edit" ? ItemMasterHsCode.product_hsn_code : ItemMasterHsCode,
      };
      await api
        .post(APIConstant.path.GetItemHSCodeSearchList, params)
        .then((res) => {
          if (res.Success == 1) {
            let Array = res.Data;
            if (Type == "Edit") {
              for (var i = 0; i < Array.length; i++) {
                if (
                  Array[i]["product_hsn_code"] ==
                  ItemMasterHsCode.product_hsn_code
                ) {
                  Array[i]["IsActiveTab"] = "1";
                  Array[i]["chapter_name"] = ItemMasterHsCode.chapter_name;
                  Array[i]["product_rate"] = ItemMasterHsCode.product_rate;
                  Array[i]["subCategory"] = ItemMasterHsCode.subCategoryId;
                  Array[i]["subWarehouse"] =
                    ItemMasterHsCode.subWarehouse?.map(
                      (warehouse) => warehouse.id
                    ) || [];
                  Array[i]["unit"] = ItemMasterHsCode.unitId;
                } else {
                  Array[i]["IsActiveTab"] = "0";
                }
              }
              Array = Array.filter(
                (item) => !CommonConfig.isEmpty(item.chapter_name)
              );
            }

            Loader.hide();
            this.setState({ loading: false, ItemSearchListHSCode: Array });
          } else {
            cogoToast.error(res.Message);
            Loader.hide();
          }
        });
    } else {
      this.setState({
        ItemMasterHsCodeErr: true,
        ItemItemMasterHsCodeErrText: "Please Enter Item HSCode",
      });
    }
  };

  DeleteItemMasterType = () => {
    Loader.show();
    let params = {
      ID: this.state.ItemMasterID,
      UserID: this.state.UserId,
    };
    api.post(APIConstant.path.DeleteItemMaster, params).then((res) => {
      if (res.Success == 1) {
        this.setState({
          loading: false,
          DeleteItemMasterTypeModal: false,
          ItemMasterID: "",
        });
        this.GetItemMasterListByType(this.state.UserId);
        cogoToast.success(res.Message);
        Loader.hide();
      } else {
        this.setState({ loading: false });
        cogoToast.error(res.Message);
        Loader.hide();
      }
    });
  };

  ActiveTab = (value, idx) => {
    let tempList = this.state.ItemSearchListHSCode;
    // if (value == "0") {
    tempList[idx]["IsActiveTab"] = "1";
    for (var i = 0; i < tempList.length; i++) {
      if (idx != i) {
        tempList[i]["IsActiveTab"] = "0";
      }
    }
    // }
    // else {
    //   tempList[idx]["IsActiveTab"] = "0";
    // }
    this.setState({ ItemSearchListHSCode: tempList });
  };
  SrNoBody = (data, props) => {
    return props.rowIndex + 1;
  };

  RateBody = (data, props) => {
    return <>{data.product_rate + "%"}</>;
  };
  DescriptionBody = (data, props) => {
    return (
      <>
        <Tooltip target=".custom-tooltip"></Tooltip>
        <div className="card">
          <span
            className="custom-tooltip"
            data-pr-tooltip={data.product_description}
          >
            {data.product_description}
          </span>
        </div>
      </>
    );
  };

  handleAddItem = (prevItem, idx) => {
    let itemSearchListHSCode = [...this.state.ItemSearchListHSCode];
    itemSearchListHSCode.map((item) => {
      item.IsActiveTab = "0";
      return item;
    });
    itemSearchListHSCode.splice(idx + 1, 0, {
      IsActiveTab: "1",
      Name: "",
      product_hsn_code: prevItem.product_hsn_code,
      product_description: prevItem.product_description,
      product_rate: prevItem.product_rate,
      subCategory: "",
      subWarehouse: [],
      unit: "",
    });

    this.setState({
      ItemSearchListHSCode: itemSearchListHSCode,
    });
  };

  handleDeleteItem = (index) => {
    let itemSearchListHSCode = [...this.state.ItemSearchListHSCode];
    itemSearchListHSCode.splice(index, 1);
    this.setState({
      ItemSearchListHSCode: itemSearchListHSCode,
    });
  };

  getTruncatedDescription = (text) => {
    if (!text) return '';
    const words = text.split(' ');
    if (words.length > 5) {
      return words.slice(0, 5).join(' ') + '...';
    }
    return text;
  };

  render() {
    const {
      UserId,
      search,
      userPageAccess,
      GetItemMasterList,
      ItemMasterLabelName,
      ItemMasterLabelNameErr,
      ItemSearchListHSCode,
      ItemItemMasterHsCodeErrText,
      ItemMasterHsCode,
      ItemMasterHsCodeErr,
      ItemMasterLabelNameErrText,
      AddItemMasterModal,
      EditItemMasterTypeModal,
      DeleteItemMasterTypeModal,
      ItemMasterID,
      subCategoryList,
      unitList,
      gstList,
      subWarehouseList,
    } = this.state;

    let filterGetItemMasterList = [];
    if (GetItemMasterList.length) {
      filterGetItemMasterList = GetItemMasterList;
      if (search) {
        filterGetItemMasterList = filterGetItemMasterList.filter((x) => {
          let searchLower = search.toLowerCase();
          return (
            (x.chapter_name || "").toString().toLowerCase().indexOf(searchLower) !== -1 ||
            (x.product_description || "").toString().toLowerCase().indexOf(searchLower) !== -1 ||
            (x.product_hsn_code || "").toString().toLowerCase().indexOf(searchLower) !== -1 ||
            (x.product_rate || "").toString().toLowerCase().indexOf(searchLower) !== -1
          );
        });
      }
    }

    return (
      <div className="wayment-owner-dashboard e-weighment-dashoard">
        <div className="heading-area p-d-flex p-ai-center p-jc-between">
          <div className="p-d-flex p-ai-center">
            <i className="pi pi-database"></i>
            <h2>Item/Goods Master</h2>
          </div>
          <div className="p-d-flex p-ai-center wb-filter-btn">
            <div className="searchbar-area p-as-center">
              <InputText
                type="search"
                onInput={(e) => this.setState({ search: e.target.value })}
                placeholder="Global Search"
                size="30"
                style={{ marginRight: 10 }}
              />
              <i className="icon-search"></i>
            </div>
            {userPageAccess.includes("Add Item/Goods") ? (
              <div>
                <div
                  className="e-add-btn"
                  onClick={(e) => this.handleOpenItem(e, "AddItemMaster")}
                >
                  <i className="icon-add"></i>
                </div>
              </div>
            ) : null}
          </div>
        </div>
        <hr />
        <div className="main-access-card-master">
          {userPageAccess.includes("View Item/Goods") ? (
            <DataTable
              className="main-table table-td"
              value={filterGetItemMasterList}
              editMode="row"
              dataKey="id"
              responsiveLayout="scroll"
              paginator={true}
              rows={this.state.rowsPerPage}
              totalRecords={filterGetItemMasterList.length}
              rowsPerPageOptions={this.state.rowsPerPageOptions}
              globalFilter={search}
              emptyMessage="No records found"
              responsive={false}
              resizableColumns={true}
              columnResizeMode="fit"
              scrollable={true}
              scrollWidth="auto"
              paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            >
              {/* <Column field="Index" header="Sr.No" body={this.actionBodyTemplateSrNo} style={{ width: '20%' }}></Column> */}
              <Column
                field="product_hsn_code"
                header="HSN Code"
                style={{ width: "20%" }}
              ></Column>
              <Column
                field="chapter_name"
                header="Chapter Name "
                style={{ width: "20%" }}
              ></Column>
              {/* <Column field="product_description" header="Product Description" style={{ width: '20%' }}></Column> */}
              <Column
                body={this.DescriptionBody}
                header="Product Description"
                style={{ width: "20%" }}
              ></Column>
              <Column
                body={this.RateBody}
                header="GST Rate"
                style={{ width: "20%" }}
              ></Column>
              {/* <Column body={this.CESSBody} header="CESS(%)" style={{ width: '20%' }}></Column> */}
              <Column
                field="Action"
                header="Action"
                body={this.actionTemplate}
                headerStyle={{ width: "10%", minWidth: "8rem" }}
                bodyStyle={{ textAlign: "center" }}
              ></Column>
            </DataTable>
          ) : null}
          {/* Add Edit BL Type */}
          <Dialog open={AddItemMasterModal} className="custom-hs-master-item">
            <DialogTitle
              id="cha-form-dialog-title"
              className="custom-dialog-header"
            >
              <div>{ItemMasterID !== "" ? "Edit" : "Add"} Item/Goods </div>
              <div
                className="dialog-close"
                onClick={(e) => this.handlehandleClose("AddItemMaster")}
              >
                <i className="icon-modal-close"></i>
              </div>
            </DialogTitle>
            <DialogContent className="HSCode-dialog-content-area">
              <GridContainer>
                <GridItem md={4}>
                  <TextField
                    autoFocus
                    margin="dense"
                    name="Item HsCode"
                    // id="chaNo"
                    label="HS Code/Product Name *"
                    type="text"
                    value={ItemMasterHsCode}
                    onChange={(e) =>
                      this.handleChangeItem(e, "ItemMasterHsCode")
                    }
                    error={ItemMasterHsCodeErr}
                    helperText={ItemItemMasterHsCodeErrText}
                    fullWidth
                  />
                </GridItem>
                <GridItem md={1}>
                  <div className="">
                    <button
                      className="filter-btn table-add-btn p-mt-3 cursor-pointer"
                      onClick={(e) => {
                        this.SearchItemCodeList(ItemMasterHsCode, "Add");
                      }}
                    >
                      <i className="icon-search"></i>{" "}
                    </button>
                  </div>
                </GridItem>
              </GridContainer>
              <GridContainer>
                <GridItem md={12}>
                  {ItemSearchListHSCode.length != 0 ? (
                    <table>
                      <tr>
                        <th style={{ minWidth: "200px" }}></th>
                        <th style={{ minWidth: "200px" }}>Item Name</th>
                        <th style={{ minWidth: "200px" }}>Sub Category</th>
                        <th style={{ minWidth: "200px" }}>Sub Warehouse</th>
                        <th style={{ minWidth: "200px" }}>Description</th>
                        <th style={{ minWidth: "50px" }}>HSN Code</th>
                        <th style={{ minWidth: "50px" }}>Unit</th>
                        <th style={{ minWidth: "50px" }}>GST Rate</th>
                        {/* <th>Action</th> */}
                      </tr>

                      {ItemSearchListHSCode.length != 0 ? (
                        ItemSearchListHSCode.map((x, idx) => {
                          return (
                            <tr
                              className={
                                x.IsActiveTab == "1"
                                  ? "active cursor-pointer "
                                  : "cursor-pointer"
                              }
                              onClick={(e) =>
                                this.ActiveTab(x.IsActiveTab, idx)
                              }
                            >
                              <td style={{ minWidth: "200px" }}>
                                {!this.state.ItemMasterID &&
                                  x.chapter_name &&
                                  x.product_rate &&
                                  x.subCategory &&
                                  x.subWarehouse?.length &&
                                  x.unit ? (
                                  <div
                                    onClick={() => this.handleAddItem(x, idx)}
                                  >
                                    <i class="icon-add"></i>{" "}
                                  </div>
                                ) : null}
                              </td>
                              <td style={{ minWidth: "200px" }}>
                                {x.IsActiveTab == "1" ? (
                                  <CustomInput
                                    className="input-no-cont"
                                    style={{ width: '200px' }}
                                    labelText="Name"
                                    formControlProps={{
                                      fullWidth: true,
                                    }}
                                    inputProps={{
                                      onChange: (e) => {
                                        e.stopPropagation();
                                        let tempList = ItemSearchListHSCode;
                                        tempList[idx]["chapter_name"] =
                                          e.target.value;

                                        this.setState({
                                          ItemSearchListHSCode: tempList,
                                        });
                                      },
                                      type: "text",
                                      id: "chapter_name",
                                      name: "chapter_name",
                                      value: x.chapter_name,
                                    }}
                                  />
                                ) : (
                                  <div
                                    // onClick={(e) =>
                                    //   this.ActiveTab(x.IsActiveTab, idx)
                                    // }
                                    style={{ width: '200px' }}
                                  >
                                    {x.chapter_name}
                                  </div>
                                )}
                              </td>
                              <td style={{ minWidth: "200px" }}>
                                {x.IsActiveTab == "1" ? (
                                  <Autocomplete
                                    id="category"
                                    name="category"
                                    value={
                                      x.subCategory && subCategoryList.length
                                        ? subCategoryList.filter(
                                          (y) => y.value == x.subCategory
                                        )[0]
                                        : ""
                                    }
                                    options={subCategoryList}
                                    getOptionLabel={(option) =>
                                      option.label ? option.label : option
                                    }
                                    onChange={(e, value) => {
                                      e.stopPropagation();
                                      let tempList = ItemSearchListHSCode;
                                      tempList[idx]["subCategory"] =
                                        value?.value;

                                      this.setState({
                                        ItemSearchListHSCode: tempList,
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="standard"
                                        placeholder="Select"
                                        label="Sub Category"
                                        className="p-mt-2 p-pt-1"
                                      />
                                    )}
                                  />
                                ) : (
                                  <div
                                    // onClick={(e) =>
                                    //   this.ActiveTab(x.IsActiveTab, idx)
                                    // }
                                    style={{ width: "120px" }}
                                  >
                                    {
                                      subCategoryList.filter(
                                        (category) =>
                                          category.value === x.subCategory
                                      )?.[0]?.label
                                    }
                                  </div>
                                )}
                              </td>
                              <td style={{ minWidth: "200px" }}>
                                {x.IsActiveTab == "1" ? (
                                  <>
                                    <TextField
                                      select
                                      label="Sub Warehouse"
                                      style={{ width: "200px" }}
                                      value={x.subWarehouse || []}
                                      onChange={(e) => {
                                        e.stopPropagation();
                                        // material TextField provides selected values in e.target.value
                                        if (e && e.target && e.target.value !== undefined) {
                                          e.value = e.target.value;
                                        }
                                        let tempList = ItemSearchListHSCode;
                                        tempList[idx]["subWarehouse"] =
                                          e?.value;

                                        this.setState({
                                          ItemSearchListHSCode: tempList,
                                        });
                                      }}
                                      SelectProps={{ multiple: true }}
                                      placeholder="Select"
                                      fullWidth
                                    >
                                      {subWarehouseList.map((warehouse) => (
                                        <MenuItem key={warehouse.value} value={warehouse.value}>
                                          {warehouse.label}
                                        </MenuItem>
                                      ))}
                                    </TextField>
                                  </>
                                ) : (
                                  <div
                                    // onClick={(e) =>
                                    //   this.ActiveTab(x.IsActiveTab, idx)
                                    // }
                                    style={{ width: "120px" }}
                                  >
                                    {subWarehouseList
                                      .filter((warehouse) =>
                                        x.subWarehouse?.includes(
                                          warehouse.value
                                        )
                                      )
                                      .map((warehouse) => warehouse.label)
                                      .join()}
                                  </div>
                                )}{" "}
                              </td>

                              <td style={{ minWidth: "200px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", cursor: "pointer" }}
                              // onClick={(e) =>
                              //   this.ActiveTab(x.IsActiveTab, idx)
                              // }
                              >
                                <MuiTooltip
                                  title={x.product_description}
                                  placement="bottom-start"
                                  arrow
                                  enterDelay={300}
                                >
                                  <span style={{ display: "inline-block", width: "100%" }}>
                                    {this.getTruncatedDescription(x.product_description)}
                                  </span>
                                </MuiTooltip>
                              </td>
                              <td style={{ minWidth: "50px" }}
                              // onClick={(e) =>
                              //   this.ActiveTab(x.IsActiveTab, idx)
                              // }
                              >
                                {x.product_hsn_code}
                              </td>
                              <td style={{ minWidth: "50px" }}>
                                {x.IsActiveTab == "1" ? (
                                  <Autocomplete
                                    id="unit"
                                    name="unit"
                                    style={{ width: "100px" }}
                                    value={
                                      x.unit && unitList.length
                                        ? unitList.filter(
                                          (y) => y.value == x.unit
                                        )[0]
                                        : ""
                                    }
                                    options={unitList}
                                    getOptionLabel={(option) =>
                                      option.label ? option.label : option
                                    }
                                    onChange={(e, value) => {
                                      e.stopPropagation();
                                      let tempList = ItemSearchListHSCode;
                                      tempList[idx]["unit"] = value?.value;

                                      this.setState({
                                        ItemSearchListHSCode: tempList,
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="standard"
                                        placeholder="Select"
                                        label="Unit"
                                      />
                                    )}
                                  />
                                ) : (
                                  <div
                                  // onClick={(e) =>
                                  //   this.ActiveTab(x.IsActiveTab, idx)
                                  // }
                                  >
                                    {
                                      unitList.filter(
                                        (unit) => unit.value === x.unit
                                      )?.[0]?.label
                                    }
                                  </div>
                                )}{" "}
                              </td>
                              <td style={{ minWidth: "50px" }}>
                                {x.IsActiveTab == "1" ? (
                                  <Autocomplete
                                    id="rate"
                                    name="rate"
                                    style={{ width: "100px" }}
                                    value={
                                      x.product_rate && gstList.length
                                        ? gstList.filter(
                                          (y) => y.value == x.product_rate
                                        )[0]
                                        : ""
                                    }
                                    options={gstList}
                                    getOptionLabel={(option) =>
                                      option.label ? option.label : option
                                    }
                                    onChange={(e, value) => {
                                      e.stopPropagation();
                                      let tempList = ItemSearchListHSCode;
                                      tempList[idx]["product_rate"] =
                                        value?.value;

                                      this.setState({
                                        ItemSearchListHSCode: tempList,
                                      });
                                    }}
                                    renderInput={(params) => (
                                      <TextField
                                        {...params}
                                        variant="standard"
                                        placeholder="Select"
                                        label="GST Rate"
                                      />
                                    )}
                                  />
                                ) : (
                                  x.product_rate
                                )}{" "}
                              </td>

                              <td style={{ width: "5%" }}>
                                {ItemSearchListHSCode.length > 1 ? (
                                  <div
                                    onClick={() => this.handleDeleteItem(idx)}
                                  >
                                    <i class="icon-delete"></i>{" "}
                                  </div>
                                ) : null}
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <div>No Records Available</div>
                      )}
                    </table>
                  ) : null}
                </GridItem>
              </GridContainer>
            </DialogContent>
            <DialogActions className="p-p-0 dialog-footer1">
              <Button
                className="primary-btn1"
                onClick={(e) => this.handlehandleClose("AddItemMaster")}
              >
                Close
              </Button>
              {!CommonConfig.isObjectEmpty(ItemSearchListHSCode) &&
                ItemSearchListHSCode.length > 0 ? (
                <Button
                  className="primary-btn"
                  onClick={(e) => this.AddItemMaster(e)}
                  type="submit"
                >
                  Submit
                </Button>
              ) : null}
            </DialogActions>
          </Dialog>

          {/* Modal For Delete */}
          <Dialog
            open={DeleteItemMasterTypeModal}
            onClose={() => this.handlehandleClose("DeleteItemMasterType")}
            aria-labelledby="cha-form-dialog-title"
          >
            <DialogTitle
              id="cha-form-dialog-title"
              className="custom-dialog-header"
            >
              <div>Delete Item/Goods</div>
              <div
                className="dialog-close"
                onClick={(e) => this.handlehandleClose("DeleteItemMasterType")}
              >
                <i className="icon-modal-close"></i>
              </div>
            </DialogTitle>
            <DialogContent className="CHA-dialog-content-area">
              <h6>Are you sure want to delete?</h6>
            </DialogContent>
            <DialogActions className="p-p-0 dialog-footer1">
              <Button
                className="primary-btn1"
                onClick={(e) => this.handlehandleClose("DeleteItemMasterType")}
              >
                Close
              </Button>
              <Button
                className="primary-btn"
                onClick={(e) => this.DeleteItemMasterType(e)}
                type="submit"
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </div>
    );
  }
}
export default Item;
